import apiClient, { extractData } from "./client";

export async function createAnnouncement(data) {
  const response = await apiClient.post("/announcements", data);
  return extractData(response);
}

export async function publishAnnouncement(id) {
  const response = await apiClient.post(`/announcements/${id}/publish`);
  return extractData(response);
}

export async function getAnnouncements(params = {}) {
  const response = await apiClient.get("/announcements", { params });
  return extractData(response);
}

export async function getAnnouncement(id) {
  const response = await apiClient.get(`/announcements/${id}`);
  return extractData(response);
}
